<div [formGroup]="form">
    <ca-numeric-stepper
        [control]="control"
        [title]="question.label | translate"
        [numericMin]="question.min"
        [numericMax]="question.max"
        [numericStep]="question.step"
        [numericMask]="question.mask"
        [attr.data-testid]="question.key"
        [id]="question.key"
    ></ca-numeric-stepper>
    @if (question.validators.length) {
        <div class="ca-subscript relative mt-2">
            @if (isInvalid && errorMessage) {
                <div class="absolute ca-error-message" @slideDown>
                    <ca-form-error-message [attr.data-testid]="question.key + '-error-message'">
                        {{ errorMessage | translate }}
                    </ca-form-error-message>
                </div>
            }
        </div>
    }
</div>
